<template>
  <div id="indicators">

    <div v-if="obvData.length">
      <h1 align="center">Indicators</h1>

      <div id="macd" class="chart3">
        <GChart 
          type="ComboChart"
          :data="macdData"
          :options="macdOptions"
        />
      </div>

      <div id="rsi" class="chart3">
        <GChart 
          type="ComboChart"
          :data="rsiData"
          :options="rsiOptions"
        />
      </div>

      <div id="obv" class="chart3">
        <GChart 
          type="ComboChart"
          :data="obvData"
          :options="obvOptions"
        />
      </div>
    </div>

  </div>
</template>
<script>
import axios from 'axios';
// import VueApexCharts from 'vue-apexcharts';
// import VueGoogleCharts from 'vue-google-charts';
import { GChart } from 'vue-google-charts'



export default {
  name: 'IndicatorsComponent',
  components:{
    GChart,
  },
  props:['ticker'],
  data() {
    return {
        // ticker: 'AAPL',
        period: '1y',
        interval: '1d',
        // ticker: null,
        // period: null,
        // interval: null,
        data: null,
        priceData: [],
        priceOptions: {
          xaxis: {
            type: 'datetime'
          },
          yaxis: {
            tooltip: {
              enabled: true
            }
          }
        },

        macdData:  [],
        macdOptions: {
            title: 'MACD',
            seriesType: 'lines',
            series: {0:{type:'bars'},1:{type:'lines'},2:{type:'lines'}},
        },
        rsiData:  [],
        rsiOptions: {
            title: 'RSI',
            seriesType: 'lines',
            series: {
                0:{type:'lines'},
                1:{type:'lines',lineDashStyle:[2,2]},
                2:{type:'lines',lineDashStyle:[2,2]},   
                },
            colors: ['blue','black','black']
        },
        obvData:  [],
        obvOptions: {
            title: 'OBV',
            seriesType: 'lines',
            series: {0:{type:'lines'},1:{type:'lines',lineDashStyle:[2,2]},},
            colors: ['blue','black']
        },
    }
  },
  // computed: {},
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      let params = {
        'ticker':this.ticker,
        'period':this.period,
        'interval':this.interval,
      }
      await axios
        .get(`${process.env.VUE_APP_DATA_API_HOST}/indicators`, {params:params})
        .then(response => {
          this.data = response.data
        //   console.log(this.data)
          this.createSeries()
        })
        .catch(e => {
          e
        })
    },
    createSeries() {
      var data = this.data['data']
      var macdData = [['Date','MACD histogram','MACD','MACD signal']]
      var rsiData = [['Date','RSI','70','30']]
      var obvData = [['Date','OBV','0']]
    
      for (var key in data){
        if (Object.prototype.hasOwnProperty.call(data,key)) {
          macdData.push([new Date(key),data[key]['MACD_crossover'],data[key]['MACD'],data[key]['MACD_signal']])
          rsiData.push([new Date(key),data[key]['RSI'],0.7,0.3])
          obvData.push([new Date(key),data[key]['OBV'],0.0])
        }
      }
      this.macdData = macdData
      this.rsiData = rsiData
      this.obvData = obvData
    }
  },
  watch:{
    ticker: function () {
      this.fetchData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chart3{
    height:33%;
    width:100%;
}
</style>